import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';

import {Subject} from 'rxjs';

import {ActivatedRoute } from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {HttpErrorResponse} from '@angular/common/http';
import {PaymentService} from '../../../core/service/payment.service';
import {takeUntil} from 'rxjs/operators';
import {ReturnPaymentInfoResponse} from '../../../core/responses/ReturnPaymentInfoResponse';
import {PAYMENT_STATUS_LABEL, PaymentStatus } from '../../../core/helpers/constants';
import {IPN_ERROR_CODE_STATUS_LABEL} from '../../../core/helpers/constants';
import {PaymentDetails} from "../../../core/models/payment-details";

@Component({
  selector: 'app-return-payment',
  templateUrl: './return-payment.component.html',
  styleUrls: ['./return-payment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslatePipe
  ],
})
export class ReturnPaymentComponent implements OnInit, OnDestroy {

  // Public
  public orderId: string = null;
  public orderDetails: PaymentDetails = null;
  public paymentStatusesLabels = PAYMENT_STATUS_LABEL;
  public ipnStatusesLabels = IPN_ERROR_CODE_STATUS_LABEL;
  public subdomain: string;
  public paymentStatusEnum = PaymentStatus;

  private ngUnsubscribe = new Subject();

  constructor(
    private _route: ActivatedRoute,
    private paymentService: PaymentService,
  ) {
    this.orderId = this._route.snapshot.params.orderId || '';
    this.subdomain = this._route.snapshot.params['subdomain'];
  }

  ngOnInit(): void {
    if (this.orderId) {
      this.getPaymentDetails();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  /**
     * Get order details
     */
  getPaymentDetails() {
    this.paymentService.returnPaymentInfo(this.orderId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        data => {
          this.onGetTaxesSuccess(data);
        },
        error => {
          this.onGetTaxesFail(error);
        });
  }

  public onGetTaxesSuccess(data: ReturnPaymentInfoResponse) {
    this.orderDetails = data.responseObject;
  }

  public onGetTaxesFail(error: HttpErrorResponse) {
  }
}
